import { Input } from "@/components/ui/input.tsx";
import { Filters } from "@somethings-ui/web";
import { useMemo } from "react";

interface ChannelListHeaderProps {
  search: string;
  setSearch: (search: string) => void;
  selectedFilter: "all" | "unread" | "check-in";
  setSelectedFilter: (filter: "all" | "unread" | "check-in") => void;
  shouldEverShowCheckinBadge?: boolean;
}

export function ChannelListHeader({
  search,
  setSearch,
  selectedFilter,
  setSelectedFilter,
  shouldEverShowCheckinBadge = false,
}: ChannelListHeaderProps) {
  const filters = useMemo(() => {
    const baseFilters = [
      {
        label: "All",
        onClick: () => setSelectedFilter("all"),
        isActive: selectedFilter === "all",
      },
      {
        label: "Unread",
        onClick: () => setSelectedFilter("unread"),
        isActive: selectedFilter === "unread",
      },
    ];

    if (shouldEverShowCheckinBadge) {
      return [
        ...baseFilters,
        {
          label: "Check-in",
          onClick: () => setSelectedFilter("check-in"),
          isActive: selectedFilter === "check-in",
        },
      ];
    }

    return baseFilters;
  }, [selectedFilter, setSelectedFilter, shouldEverShowCheckinBadge]);
  return (
    <div className="border-b p-2">
      {/* <h2 className="mb-2 text-lg font-bold">Sort</h2> */}

      {/* <div className="flex flex-row mb-4">
        <button className="text-black text-sm border border-gray-200 px-3 py-1 rounded-full active:bg-gray-200 ">
          Last teen message
        </button>
      </div> */}

      <div className="flex flex-col gap-2">
        <Input
          type="text"
          placeholder="Search"
          className="w-full rounded-xl"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
        />
        <Filters items={filters} />
      </div>
    </div>
  );
}
